var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      key: _vm.key,
      style: _vm.tabsStyling,
      attrs: {
        value: _vm.activeTab,
        "background-color": "transparent",
        "show-arrows": "",
        centered: "",
        height: "57px"
      }
    },
    [
      _c("v-tabs-slider", { attrs: { color: "accent" } }),
      _vm._v(" "),
      _vm._l(_vm.tabs, function(tab, index) {
        return _c(
          "v-tab",
          {
            key: tab.label,
            staticStyle: { "text-transform": "none", "font-size": "12px" },
            on: {
              change: function($event) {
                return _vm.$emit("startTabChange", index)
              }
            }
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.translateLabels
                    ? _vm.$tc(_vm.getTranslationKey(tab.label), 2)
                    : tab.label
                ) +
                "\n  "
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f48fc2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f48fc2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Organisms/Tabs.vue
// module id = null
// module chunks = 